export default "__VITE_ASSET__DpUdKhjI__"